import { h, FunctionComponent } from 'preact';
import { useEffect } from 'preact/hooks';
import { Trans, useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import * as styles from '~src/styles/domains/noi/NOIPage.module.scss';
import { MAX_POLL_CALLS } from '~src/utils/constants';
import { trackPageMount } from '~src/utils/tracking';
import { Page } from '../common/enums/api';
import { general } from '../common/state/commonReducer';
import {
  brandSelector,
  customerInfoSelector,
} from '../common/state/commonSelectors';

export default function NOIPage() {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const brand = useSelector(brandSelector);

  useEffect(() => {
    dispatch(trackPageMount(Page.NOI));
    dispatch(
      general({
        isOfferExpired: true,
        pollCallCount: MAX_POLL_CALLS,
      }),
    );
  }, []);

  const customerInfo = useSelector(customerInfoSelector);
  const firstName = customerInfo.first_name;

  const header = t('noi:header');
  const greeting = (
    <Trans t={t} i18nKey='noi:greeting' values={{ name: firstName }} />
  );
  const nextSteps = t('noi:nextSteps');
  const thanks = t('noi:thanks');

  return (
    <div className={styles.body} id='noi-page-container'>
      <div
        className={`header-txt ${styles.header} noi-header`}
        id='noi-page-header'
      >
        {header}
      </div>
      <div className={styles.text} id='noi-page-description'>
        <p>{greeting}</p>
        <p>{nextSteps}</p>
        <p>{thanks}</p>
      </div>
    </div>
  );
}
